import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchProcess(params) {
  return await request({
    url: ENDPOINT.HOME_PROCESS,
    method: "get",
    params,
  });
}

export async function fetchProcessById(id) {
  return await request({
    url: `${ENDPOINT.HOME_PROCESS}/${id}`,
    method: "get",
  });
}

export async function createProcess(data) {
  return await request({
    url: ENDPOINT.HOME_PROCESS,
    method: "post",
    data,
  });
}

export async function updateProcess(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_PROCESS}/${id}`,
    method: "post",
    data,
  });
}

export async function deleteProcess(id) {
  return await request({
    url: `${ENDPOINT.HOME_PROCESS}/${id}`,
    method: "delete",
  });
}